import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-command",
  "use": "icon-command-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 24\" id=\"icon-command\"><defs></defs><g id=\"icon-command_border\"><path class=\"cls-1\" d=\"M.28,0H0L5.77,12,0,24H26.21L32,12,26.21,0H.28Z\" /></g><g id=\"icon-command_fill\"><path class=\"cls-2\" d=\"M26.21,0H.86C.57,0,.28,0,0,0L5.77,12,0,24c.28,0,.57,0,.86,0H26.21L32,12Z\" /><path class=\"cls-1\" d=\"M25,2l4.82,10L25,22H3.18l4.39-9.12L8,12l-.42-.87L3.18,2H25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol